function Spinner({ loading }) {
    return (
        <span className="spinner_cont">
            {loading && (
                <span id="spinner" className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </span>
            )}
        </span>
    );
}

export default Spinner;
